import $ from 'jquery';

/**
 * AnimateScrollV1 widget configs
 */
const animateScrollV1Semantics = {
    'mainWrapClass': 'animate-scroll-v1',
    'scrollSpeed': 300, //speed in ms 1000ms = 1sec
    'spacing': 200, // in px
};

$(function () {
    let elements = $('.' + animateScrollV1Semantics.mainWrapClass);
    if(!elements.length) {
        return false;
    }
    AnimateScrollV1.init();
});

class AnimateScrollV1 {
    constructor() {
        this.pluginInstances = {};
    }


    static init() {
        if (!window || !window.widgets || !window.widgets.animateScrollV1) {
            window.widgets.animateScrollV1 = new AnimateScrollV1();
            window.widgets.animateScrollV1.registerListeners();
        }
    }


    registerListeners() {
       $('html, body').on(
            'click',
            `.${animateScrollV1Semantics.mainWrapClass}`,
            (e) => {
                e.preventDefault();
                let current = $(e.currentTarget);
                e.preventDefault();
                let targetId = current.attr('href');

                let $target = $(targetId);
                if ($target.length) {
                    $('html, body').animate({
                        scrollTop: $target.offset().top * 1 - animateScrollV1Semantics.spacing
                    }, animateScrollV1Semantics.scrollSpeed);
                }
            }
        );
    }

    reInit(instanceId) {
        AnimateScrollV1.init();
    }
}